import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';

const links = [
  { to: '/', label: 'Home', end: true },
  { to: '/services', label: 'Services' },
  { to: '/portfolio', label: 'Work' },
  { to: '/about', label: 'About' },
  { to: '/blog', label: 'Blog' },
];

const V2Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => setOpen(false), [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [open]);

  return (
    <>
      <nav className={`v2-nav ${scrolled ? 'v2-nav--scrolled' : ''}`}>
        <div className="v2-container v2-nav__inner">
          <Link to="/" className="v2-nav__brand" aria-label="Cosmik Drones home">
            <img src="/Cosmik Logo/Kolonia_Logo.png" alt="Cosmik Drones logo" width="120" height="120" />
            <span className="v2-nav__wordmark">Cosmik Drones</span>
          </Link>

          <div className="v2-nav__links">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.end}
                className={({ isActive }) =>
                  `v2-nav__link ${isActive ? 'v2-nav__link--active' : ''}`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link to="/contact" className="v2-btn v2-btn--primary v2-nav__cta">
              Request a Quote
            </Link>
          </div>

          <button
            className="v2-nav__toggle"
            aria-label="Open menu"
            onClick={() => setOpen(true)}
          >
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M4 7h16M4 12h16M4 17h16" strokeLinecap="round" />
            </svg>
          </button>
        </div>
      </nav>

      {open && (
        <div className="v2-nav__mobile">
          <button
            className="v2-nav__close"
            onClick={() => setOpen(false)}
            aria-label="Close menu"
          >
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M6 6l12 12M18 6L6 18" strokeLinecap="round" />
            </svg>
          </button>
          {links.map((l) => (
            <Link key={l.to} to={l.to}>{l.label}</Link>
          ))}
          <Link to="/contact" className="v2-btn v2-btn--primary" style={{ marginTop: '2rem' }}>
            Request a Quote
          </Link>
        </div>
      )}
    </>
  );
};

export default V2Nav;
